import React, { Suspense } from 'react';
import { gql, useQuery } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import Helmet from 'react-helmet';
import { AcVideoPublic } from '../organisms/AcVideoPublic';
const videoPageLoaderQuery = gql `
  query videoPageQuery($companyContractDisplayId: Int!, $videoPageHashPath: String!) {
    videoPage(companyContractDisplayId: $companyContractDisplayId, videoPageHashPath: $videoPageHashPath) {
      videoPageId
      videoPageDisplayId
      langCode
      publishScope
      videoPageTitle
      videoPageSubTitle
      videoPageDescription
      publicStartDatetime
      publicEndDatetime
      videoPageUrl
      videoThumbnailImageUrl
      videoUrl
      versionId
      authorCompany {
        companyName
        companyLogoUrl
        tel
      }
      tvWebinarCompany {
        companyLogoUrl
        companyName
      }
      videoPageProductCategories {
        productCategoryId
        productCategoryName
        productCategoryBreadCrumbs {
          productCategoryId
          productCategoryName
        }
        displayOrder
      }
      releaseStatus
      videoFileUploadStatus {
        replace
        type
        label
      }
      status {
        type
        label
      }
      createdOperator
      lastUpdatedOperator
      createTimestamp
      updateTimestamp
      deleteFlag
    }
  }
`;
export const AcVideoView = ({ companyContractDisplayId = -1, videoPageHashPath = '' }) => {
    const history = useHistory();
    // useEffect(() => {
    //  const oldTitle = document.title;
    //
    //  return () => {
    //    document.title = oldTitle;
    //  };
    // }, []);
    const { loading, data, error } = useQuery(videoPageLoaderQuery, {
        variables: {
            companyContractDisplayId,
            videoPageHashPath,
        },
        // fetchPolicy: 'network-only', // don't want to be network only so can put data in video preview from form using local cache
        // would want network only so that will see video edits immediately
    });
    // useEffect(() => {
    //  document.title = data?.videoPage?.videoPageTitle || '';
    // }, [data]);
    return (React.createElement(React.Fragment, null, !loading && (React.createElement(React.Fragment, null,
        React.createElement(Helmet, null,
            React.createElement("meta", { name: "description", content: data?.videoPage.videoPageDescription }),
            React.createElement("meta", { property: "og:image", content: data?.videoPage.videoThumbnailImageUrl })),
        React.createElement(Suspense, { fallback: React.createElement("h1", { style: { display: 'none' } }, "LOADING") },
            React.createElement("div", { className: `container-fluid p-0` },
                React.createElement("div", { className: `row justify-content-center no-gutters` },
                    React.createElement("div", { className: `col-12` },
                        React.createElement(AcVideoPublic, { videoPage: data?.videoPage })))))))));
};
AcVideoView.displayName = 'AcVideoView';
